import { ThemeName, ThemeNames } from 'constantsValues/themeNames';
import { useThemeName } from './useThemeName';

export type DesignSystemThemeName = Exclude<ThemeName, (typeof ThemeNames)['almbrand']>;

const isDesignSystemThemeName = (themeName: ThemeName): themeName is DesignSystemThemeName => {
	return themeName !== ThemeNames.almbrand;
};

export const useDesignSystemThemeName = (): DesignSystemThemeName => {
	const themeName = useThemeName();

	if (isDesignSystemThemeName(themeName)) {
		return themeName;
	}

	return ThemeNames.codan;
};
